import { render } from "./PVP.vue?vue&type=template&id=5a16762a"
import script from "./PVP.vue?vue&type=script&lang=js"
export * from "./PVP.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/Lineage-2-Vue-JS-3-Frontend/Lineage-2-Vue-JS-3-Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__